export default "__VITE_ASSET__DwRC16qW__"